<template>
  <div>
  <div class="register-box">
    <div class="login-logo "><h2 class="text-white">Django-Advanced-Chat</h2></div>

    <div class="register-box-body">
      <template v-if="!resetCompleted">
        <p class="login-box-msg">Задайте новый пароль</p>
        <form method="post" @submit.prevent="submit" class="form-element">
          <div class="form-group has-feedback">
            <input type="password" class="form-control" v-model.lazy="inputs.password1" placeholder="Пароль" required>
            <span class="ion ion-locked form-control-feedback "></span>
            <p  class="error-field text-danger" v-show="resetError" v-for="error in fieldErrors('new_password')" :key="error">{{ error }}</p>
          </div>
          <div class="form-group has-feedback">
            <input type="password" class="form-control" v-model.lazy="inputs.password2" placeholder="Повтор пароля" required>
            <span class="ion ion-log-in form-control-feedback "></span>
            <span class="error-field text-danger" v-show="resetError" v-for="error in fieldErrors('password2')" :key="error">{{ error }}</span>
          </div>
          <div class="row">

            <div class="col-12 text-center">
              <div class="alert alert-danger" role="alert" v-show="resetError" v-for="error in fieldErrors('non_field_errors')" :key="error">
                  {{ error }}
              </div>
            </div>
            <div class="col-12 text-center">
              <button type="submit" @click="resetPassword(inputs)" class="btn btn-info btn-block btn-flat margin-top-10">Сменить пароль</button>
            </div>
            <!-- /.col -->
          </div>
        </form>
        </template>
        <template v-else>
          Ваш пароль успешно изменён!
          <p>
            <router-link to="/login" class="btn btn-info btn-block btn-flat margin-top-10">Вернуться на страницу входа</router-link>
          </p>
        </template>

    </div>
    <!-- /.form-box -->
  </div>
  <!-- /.register-box -->
</div>
<!--  <b-modal v-model="password_reset_confirm" hide-footer @hidden="goToIndex" title="Восстановление пароля">-->
<!--    <div id="password-reset-confirm-view">-->
<!--      <template v-if="resetLoading">-->
<!--        загрузка...-->
<!--      </template>-->
<!--      <template v-else-if="!resetCompleted">-->
<!--        <form @submit.prevent="submit" class="form-element">-->
<!--          <input v-model="inputs.password1" class="form-control" type="password" id="new_password1" placeholder="Пароль">-->
<!--          <span  class="error-field" v-show="resetError" v-for="error in fieldErrors('new_password1')" :key="error">{{ error }}</span>-->
<!--          <input v-model="inputs.password2" class="form-control" type="password" id="new_password2" placeholder="Пароль повторно">-->
<!--          <span  class="error-field" v-show="resetError" v-for="error in fieldErrors('new_password2')" :key="error">{{ error }}</span>-->
<!--        </form>-->
<!--        <button @click="resetPassword(inputs)" class="btn btn-info btn-block btn-flat margin-top-10">-->
<!--          сменить пароль-->
<!--        </button>-->
<!--        <div class="col-12 text-center">-->
<!--              <div class="alert alert-danger" role="alert" v-show="resetError" v-for="error in fieldErrors('non_field_errors')" :key="error">-->
<!--                  {{ error }}-->
<!--              </div>-->
<!--          </div>-->
<!--      </template>-->
<!--      <template v-else>-->
<!--        Ваш пароль успешно изменён!-->
<!--        <p>-->
<!--          <router-link to="/login">вернуться на страницу входа</router-link>-->
<!--        </p>-->
<!--      </template>-->
<!--    </div>-->
<!--  </b-modal>-->
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  data() {
    return {
      inputs: {
        password1: '',
        password2: '',
        uid: this.$route.params.uid,
        token: this.$route.params.token,
      },
      password_reset_confirm: true
    };
  },
  computed: mapState('password', [
    'resetCompleted',
    'resetError',
    'resetLoading',
    'errors'
  ]),
  methods: {
    ...mapActions('password', [
      'resetPassword',
      'clearResetStatus',
    ]),
    goToIndex: function(){
      this.$router.push('/')
    },
    fieldErrors: function (field) {
      if (field in this.errors) {
        return this.errors[field]
      }
      return []
    }
  },

};
</script>

<style>
form input {
  display: block
}
</style>
